import { Component, ViewChild } from '@angular/core';
import { NavController, AlertController, LoadingController, Loading, Platform, MenuController, Nav, Events } from 'ionic-angular';

import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";


import { TranslateService } from '@ngx-translate/core';
import { TreeComponent } from 'angular-tree-component';

import * as moment from 'moment';

@Component({
	templateUrl : 'app.html'
})
export class NouveauxChapitresApp {
	 @ViewChild(Nav) private nav : Nav;
   @ViewChild(TreeComponent) private tree: TreeComponent;

  private loading: Loading = null;

  rootPage : string = 'WelcomePage';
  pages : Array<any> = [];
  pageNodes : Array<any> = [];

  openPageNode = ($event) => this.openNode($event.node);

	constructor(
		readonly platform : Platform,
    readonly statusBar: StatusBar,
    readonly splashScreen: SplashScreen,
		readonly menu : MenuController,
    readonly alertController: AlertController,
    readonly loadingController: LoadingController,
    readonly events: Events,
		readonly translate : TranslateService) {

		this.initializeApp();
		this.initializeLang();

    this.subscribeToAccessManagerEvents();

    this.initializePagesForNavMenu();
	}

	initializeLang() {
    let defaultLang = 'fr';
    let validLangs = ["enUS", "fr"];
		let browserLang = navigator.language.split('-')[0]; // use navigator lang if available
		let userLang = browserLang.match(/enUS|fr/gi) ? browserLang : defaultLang;

    moment.locale(userLang);

		// this language will be used as a fallback when a translation isn't found in the current language
		this.translate.setDefaultLang(defaultLang);

		// the lang to use, if the lang isn't available, it will use the current loader to get them
		this.translate.use(userLang);
	}

	initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      if (this.platform.is('cordova')) {
        this.statusBar.styleDefault();
        this.splashScreen.hide();
      }
    });
	}

  initializePagesForNavMenu() {
    let part1Children = [];
    let part2Children = [];
    let part3Children = [];
    let part4Children = [];

    this.translate.get('WELCOME_TITLE').subscribe((text: string) => {
      part1Children.push({
        name: text,
        data: {
          link: 'WelcomePage'
        }
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });
    /*this.translate.get('DETAILS_TITLE').subscribe((text: string) => {
      part1Children.push({
        name: text,
        data: {
          link: 'DetailsPage'
        }
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });*/
    this.translate.get('SCHEDULE_TITLE').subscribe((text: string) => {
      part1Children.push({
        name: text,
        data: {
          link: 'SchedulePage'
        }
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });
    this.translate.get('INFORMATION_TITLE').subscribe((text: string) => {
      part1Children.push({
        name: text,
        data: {
          link: 'InformationPage'
        }
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });
    this.translate.get('HONEYMOON_TITLE').subscribe((text: string) => {
      part1Children.push({
        name: text,
        data: {
          link: 'HoneymoonPage'
        }
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });
    this.translate.get('STD_TITLE').subscribe((text: string) => {
      part2Children.push({
        name: text,
        data: {
          link: 'SaveTheDatePage'
        }
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });
    this.translate.get('RSVP_TITLE').subscribe((text: string) => {
      part2Children.push({
        name: text,
        data: {
          link: 'RSVPPage'
        }
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });
    /*this.translate.get('GUEST_OFFERS_TITLE').subscribe((text: string) => {
      part2Children.push({
        name: text,
        data: {
          link: 'GuestOffersPage'
        }
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });*/
    this.translate.get('FORUM_TITLE').subscribe((text: string) => {
      part2Children.push({
        name: text,
        data: {
          link: 'TopicsPage'
        }
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });
    this.translate.get('REGISTRY_TITLE').subscribe((text: string) => {
      part2Children.push({
        name: text,
        data: {
          link: 'RegistryPage'
        }
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });

    this.translate.get('PHOTO_GALLERY_TITLE').subscribe((text: string) => {
      part3Children.push({
        name: text,
        data: {
          link: 'GalleryPage'
        }
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });
    /*this.translate.get('FILM_GALLERY_TITLE').subscribe((text: string) => {
      part3Children.push({
        name: text,
        data: {
          link: 'FilmPage'
        }
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });*/
    /*this.translate.get('MUSIC_GALLERY_TITLE').subscribe((text: string) => {
      part3Children.push({
        name: text,
        data: {
          link: 'MusicPage'
        }
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });*/
    /*this.translate.get('TEXT_GALLERY_TITLE').subscribe((text: string) => {
      part3Children.push({
        name: text,
        data: {
          link: 'SpeechPage'
        }
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });*/
    /*this.translate.get('GUEST_LIST_TITLE').subscribe((text: string) => {
      part4Children.push({
        name: text,
        data: {
          link: 'GuestListPage'
        }
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });*/
    /*this.translate.get('ANECDOTES_TITLE').subscribe((text: string) => {
      part4Children.push({
        name: text,
        data: {
          link: 'AnecdotesPage'
        }
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });*/
    this.translate.get('GUESTBOOK_TITLE').subscribe((text: string) => {
      part3Children.push({//part4Children.push({
        name: text,
        data: {
          link: 'GuestBookPage'
        }
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });
    this.translate.get('ADDRESS_TITLE').subscribe((text: string) => {
      part3Children.push({//part4Children.push({
        name: text,
        data: {
          link: 'AddressPage'
        }
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });

	
	
    this.translate.get('PLANNING_TITLE').subscribe((text: string) => {
      this.pageNodes.push({
        name: text,
        isExpanded: true,
        hasChildren: true,
        children: part1Children
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });
    this.translate.get('PREPARATION_TITLE').subscribe((text: string) => {
      this.pageNodes.push({
        name: text,
        isExpanded: true,
        hasChildren: true,
        children: part2Children
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });
    this.translate.get('HIGHLIGHTS_TITLE').subscribe((text: string) => {
      this.pageNodes.push({
        name: text,
        isExpanded: true,
        hasChildren: true,
        children: part3Children
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });
    /*this.translate.get('MEMORIES_TITLE').subscribe((text: string) => {
      this.pageNodes.push({
        name: text,
        isExpanded: true,
        hasChildren: true,
        children: part4Children
      });
      this.tree.treeModel.update();
      this.tree.treeModel.expandAll();
    });*/
  }

  openNode(node) {
    console.log('node',node);
    if(node.data.data !== undefined) {//TODO: find if leaf
      this.open(node.data.data.link, node.data.name);
    } else {
      //TODO: expand
      console.log("opening node",node.data);
    }
  }

	openPage(page) {
    this.open(page.link, page.title);
	}

	open(link, title) {
    if(link !== undefined) {
      console.log('open page '+title+' at '+link);
      // close the menu when clicking a link from the menu
      this.menu.close();
      this.goToPage({link: link, data: {}});
    }
	}

  subscribeToAccessManagerEvents() {
    this.events.subscribe("nav:login", (data) => { this.goToLogin(); });
    this.events.subscribe("nav:page", (data) => { this.pushPage(data); });
    this.events.subscribe("loading:show", (data) => { this.showLoading();});
    this.events.subscribe("loading:hide", (data) => { this.hideLoading();});
    this.events.subscribe("error", (data) => { this.showError(data);});
  }

  goToLogin() {
    this.nav.setRoot('LoginPage');
  }

  pushPage(data: any) {
    // navigate to the new page if it is not the current page, and keep previous navigation history
    this.nav.push(data.link, data.data)
              .then(result => {
                      console.warn("Cannot access ("+data.link+"). Will redirect to login page instead");
                      if(!result && data.link != 'LoginPage') {
                        console.warn("Cannot access desired page. Going to login.");
                        this.goToLogin();
                      }
                    });
  }

  goToPage(data: any) {
      // navigate to the new page if it is not the current page, and erase previous navigation history
      this.nav.setRoot(data.link, data.data)
                .then(result => {
                      console.warn("Cannot access ("+data.link+"). Will redirect to login page instead");
                      if(!result && data.link != 'LoginPage') {
                        console.warn("Cannot access desired page. Going to login.");
                        this.goToLogin();
                      }
                    });
  }

  showLoading() {
    this.loading = this.loadingController.create({
      content: 'Veuillez patienter...'//TODO: i18n
    });
    this.loading.present();
  }

  hideLoading() {
    if(this.loading != null) {
      this.loading.dismiss();
      this.loading = null;
    }
  }

  showError(text: string) {
    setTimeout(() => {
      this.hideLoading();
    });
    console.error("Error: "+text);

    let alert = this.alertController.create({
      title: 'Erreur',//TODO: i18n
      message: text,
      buttons: ['OK']//TODO: i18n
    });
    alert.present(prompt);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts